module.exports = __webpack_public_path__ + "img/yszc-sj.271e70ed.png";